// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAmusd } from "../../../icons/full/build/icon-amusd.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AmusdIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAmusd.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AmusdIcon.displayName = 'AmusdIcon';
}

export default AmusdIcon;